import { render, staticRenderFns } from "./MSecondaryNews.vue?vue&type=template&id=ae187114&"
import script from "./MSecondaryNews.vue?vue&type=script&lang=ts&"
export * from "./MSecondaryNews.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports